import { makeAutoObservable } from "mobx";

class FullscreenStore {
  isFullscreen: boolean = false;
  /** Ref-count for "hide nav" from CallModal. Nav hidden when > 0 or hideNavSet is true. */
  private hideNavRefCount = 0;
  /** Legacy flag for setHideNav (e.g. explore layout). */
  private hideNavSet = false;

  constructor() {
    makeAutoObservable(this);
  }

  get hideNav(): boolean {
    return this.hideNavRefCount > 0 || this.hideNavSet;
  }

  /** Request nav hidden (e.g. CallModal open). Pair with releaseHideNav on close. */
  requestHideNav() {
    this.hideNavRefCount += 1;
  }

  /** Release one hide-nav request (e.g. CallModal close). */
  releaseHideNav() {
    this.hideNavRefCount = Math.max(0, this.hideNavRefCount - 1);
  }

  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;
  }

  setFullscreen(fullscreen: boolean) {
    this.isFullscreen = fullscreen;
  }

  setHideNav(hide: boolean) {
    this.hideNavSet = hide;
  }
}

export const fullscreenStore = new FullscreenStore();
